import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ContractPage } from '@/features/finance';

/** `?projectId=` starts the contract from a project (its client and the project are pre-filled). */
const NewContractSearchSchema = z.object({
  projectId: z.string().trim().min(1).max(64).optional().catch(undefined),
});

/** A new contract. The project's Finance tab links here when it has no accepted quote. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/contracts/new')({
  validateSearch: (search) => NewContractSearchSchema.parse(search),
  component: NewContractRoute,
});

function NewContractRoute() {
  const { orgId } = Route.useParams();
  const { projectId } = Route.useSearch();
  return <ContractPage orgId={orgId} projectId={projectId} />;
}
